module.exports = __webpack_public_path__ + "img/SeedIcon.22588154.png";